// extracted by mini-css-extract-plugin
export default {"files":"Files_files__gxwmM"};